<template>
  <div class="not-found-block">
    <div class="not-found-block__top">
      <router-link to="/" class="not-found-block__logo">
        <Icon name="logo/logo"/>
      </router-link>
    </div>
    <div class="not-found-block__base">
      <div class="not-found-block__content">
        <p class="not-found-block__number">
          {{ number }}
        </p>

        <p class="not-found-block__title h5">
          {{ title }}
        </p>

        <p class="not-found-block__text text-small">
          {{ text }}
        </p>

        <div class="not-found-block__action">
          <AppButton :data="action"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';
import AppButton from '@/components/AppButton/AppButton.vue';

export default {
  name: 'NotFoundBlock',
  components: {
    AppButton,
    Icon,
  },
  data() {
    return {
      number: '404',
      title: 'Страница не найдена',
      text: 'Возможно, вы указали неправильный адрес, или страница была удалена',
      action: {
        text: 'Перейти на главную',
        title: 'Перейти на главную',
        href: '/',
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import "NotFoundBlock";
</style>
